/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Crumb_CatalogInputs */

const en_endpoint_crumb_catalog = /** @type {(inputs: Endpoint_Crumb_CatalogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catalog`)
};

const zh_hans1_endpoint_crumb_catalog = /** @type {(inputs: Endpoint_Crumb_CatalogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目录`)
};

const pt_br2_endpoint_crumb_catalog = /** @type {(inputs: Endpoint_Crumb_CatalogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catálogo`)
};

const es_endpoint_crumb_catalog = /** @type {(inputs: Endpoint_Crumb_CatalogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catálogo`)
};

const fr_endpoint_crumb_catalog = /** @type {(inputs: Endpoint_Crumb_CatalogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catalogue`)
};

const de_endpoint_crumb_catalog = /** @type {(inputs: Endpoint_Crumb_CatalogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katalog`)
};

const ru_endpoint_crumb_catalog = /** @type {(inputs: Endpoint_Crumb_CatalogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Каталог`)
};

const it_endpoint_crumb_catalog = /** @type {(inputs: Endpoint_Crumb_CatalogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catalogo`)
};

/**
* | output |
* | --- |
* | "Catalog" |
*
* @param {Endpoint_Crumb_CatalogInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_crumb_catalog = /** @type {((inputs?: Endpoint_Crumb_CatalogInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Crumb_CatalogInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_crumb_catalog(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_crumb_catalog(inputs)
	if (locale === "es") return es_endpoint_crumb_catalog(inputs)
	if (locale === "fr") return fr_endpoint_crumb_catalog(inputs)
	if (locale === "de") return de_endpoint_crumb_catalog(inputs)
	if (locale === "ru") return ru_endpoint_crumb_catalog(inputs)
	if (locale === "it") return it_endpoint_crumb_catalog(inputs)
	return en_endpoint_crumb_catalog(inputs)
});